<a
    class="prom-dropdown__listitem prom-dropdown__listitem-link"
    href={option.url}
    ping={option.ping}
    id={option.id}
    tabindex="-1"
    target={option.target ? option.target : 'mainmenu'}
    on:click={onClick}
    on:mouseenter={event => dispatch('mouseenter', { event, data: option })}
    on:mouseleave={event => dispatch('mouseleave', { event, data: option })}
>

    {#if option.icon}
    <img
      alt=""
      class="prom-dropdown__listitems-icon"
      src="{option.icon}"
      height="{option.iconsize}"
      width="{option.iconsize}" />
    {:else if option.iconCssClass}
    <span
        class="{option.iconCssClass}">
    </span>
    {/if}

    <span class="prom-dropdown__listitems-text">{option.label}
    {#if option.ellipsis}
    &#8230;
    {/if}
    </span>
</a>

<script>
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    /** @type {object} */
    export let option = null;

    function onClick(event) {
        dispatch('dropdownClose', event)
        if (option && option.value) {
            dispatch('click', { data: option });
        }
    }
</script>
